import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import Contact from "./pages/contact/Contact";
import AboutUs from "./pages/about/AboutUs";
import Clientele from "./pages/blog/Clientele";
import Gallery from "./pages/gallery/Gallery";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/clientele" element={<Clientele />} />
            <Route path="/our-gallery" element={<Gallery />} />
            <Route path="/contact-us" element={<Contact />} />

          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
